import { render, staticRenderFns } from "./UniBank.vue?vue&type=template&id=cb958574&scoped=true&"
import script from "./UniBank.vue?vue&type=script&lang=js&"
export * from "./UniBank.vue?vue&type=script&lang=js&"
import style0 from "./UniBank.vue?vue&type=style&index=0&id=cb958574&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb958574",
  null
  
)

export default component.exports